import React, { useCallback, useMemo } from 'react';
import { Tabs as AntdTabs } from 'antd';
import { useNavigate, useLocation } from 'react-router';
import qs from 'qs';
import { pick } from 'ramda';

export const { TabPane } = AntdTabs;
interface TabItem {
  key: string;
  label: React.ReactNode;
  children: React.ReactNode;
  css?: string;
  forceRender?: boolean;
}

interface Props {
  items?: TabItem[];
  onChange?: (p: string) => void;
  tabParam?: string;
  defaultActiveKey?: string;
  activeKey?: string;
  tabBarExtraContent?: React.ReactNode;
}

// params listed here won't be removed from the url when changing tabs;
const whitelistQSparams: string[] = [];

export const Tabs: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  onChange,
  tabParam = '_',
  defaultActiveKey,
  activeKey,
  ...props
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { search } = location;

  const query = useMemo(
    () => qs.parse(search, { ignoreQueryPrefix: true }),
    [search]
  );

  const myOnChange = useCallback(
    (tabkey) => {
      const mySearch = qs.stringify({
        ...pick(whitelistQSparams, query),
        [tabParam]: tabkey,
      });

      navigate({ ...location, search: mySearch });
      if (onChange) onChange(tabkey);
    },
    [navigate, location, onChange, query, tabParam]
  );
  const myActiveKey = query[tabParam] || activeKey || defaultActiveKey;

  const tabsProps = {
    onChange: myOnChange,
    defaultActiveKey,
    activeKey: String(myActiveKey),
  };

  return (
    <AntdTabs
      css={`
        .ant-tabs-nav {
          background: #fff;
          padding: 0 37px;
        }
        .ant-tabs-tab,
        ant-tabs-ink-bar {
          display: inline-block;
          min-width: 120px;
          font-weight: 500;
          text-align: center;
        }
        .ant-tabs-content-holder {
          margin: 12px 24px;
        }
      `}
      {...tabsProps}
      {...props}
    />
  );
};
